import React from 'react';
import './HowHappen.scss';
import { safeHtml } from '../../../../services/helpers';
import StrapiImageWithSkeleton from '../../../../components/StrapiImageWithSkeleton/StrapiImageWithSkeleton';

export default function HowHappen({ content }) {
    return (
        <div className='workshop-how_happen'>
            <div className='workshop-how_happen__container'>
                <div className="workshop-how_happen__text" dangerouslySetInnerHTML={safeHtml(content.Texte)} />
                <div className="workshop-how_happen__image-container">
                    <div className="workshop-how_happen__image-wrapper">
                        <StrapiImageWithSkeleton
                            picture={content.Photo}
                            loading="lazy"
                            size='small'
                            className="crisis-go_to_workshop__picture"
                        />
                    </div>
                    <div className="workshop-how_happen__image-shadow"></div>
                </div>
            </div>
        </div>
    )
}